// extracted by mini-css-extract-plugin
module.exports = {"base":"Title_base__3QowF"};